"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const head_1 = __importDefault(require("next/head"));
const react_swipeable_1 = require("react-swipeable");
const router_1 = require("next/router");
const dynamic_1 = __importDefault(require("next/dynamic"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const usePageScrollRestore_1 = require("../../hooks/usePageScrollRestore");
const Alert_1 = require("./Alert");
const helpers_1 = require("../../lib/helpers");
const ErrorToolTip_1 = require("./ErrorToolTip");
const Journey_1 = require("../../lib/Journey");
const NoSSRStatusBarNotch = dynamic_1.default(() => Promise.resolve().then(() => __importStar(require('../Util/StatusBarNotch'))), { ssr: false });
let lastRouteChangeAt;
const JourneyApp = (props) => {
    const { children, authed } = props;
    usePageScrollRestore_1.usePageScrollRestore();
    const router = router_1.useRouter();
    const previousPageHtmlRef = react_1.useRef('');
    const [error, setError] = react_1.useState();
    const lastSwipeGestureAtRef = react_1.useRef(0);
    const [alertPayload, setAlertPayload] = react_1.useState();
    const { ref: swipeRef } = react_swipeable_1.useSwipeable({
        onSwipedLeft: () => {
            lastSwipeGestureAtRef.current = Date.now();
        },
        onSwipedRight: () => {
            /* Native iOS webview does not automatically go back on swipe, but safari does. */
            if (helpers_1.isUsingAppWebview()) {
                router.back();
            }
            // todo: doesnt work?
            lastSwipeGestureAtRef.current = Date.now();
        },
    });
    react_1.useEffect(() => {
        swipeRef(document);
    });
    const initialRoutePath = react_1.useRef(router.asPath);
    const hasNavigatedRef = react_1.useRef(false);
    react_1.useEffect(() => {
        if (initialRoutePath.current !== router.asPath) {
            hasNavigatedRef.current = true;
        }
    }, [router.asPath]);
    const appEleRef = react_1.useRef(null);
    const [previousPageClass, setPreviousPageClass] = react_1.useState('beneath');
    const [appClass, setAppClass] = react_1.useState('first-render');
    react_1.useEffect(() => {
        if (!hasNavigatedRef.current) {
            return;
        }
        const curTime = Date.now();
        lastRouteChangeAt = curTime;
        if (!Journey_1.Journey.config.pageTransitions || lastSwipeGestureAtRef.current > (curTime - 2000)) {
            setAppClass('active');
            return;
        }
        setAppClass('enter');
        // let the css recognize the away render to -100vw left
        setTimeout(() => {
            // "enter" css class will place the new page on the right side (left: 100vw), switching it to active will then transition to left: 0;
            setAppClass('active');
            setPreviousPageClass('away');
            setTimeout(() => {
                /* Did we transition again between transitioning? */
                if (lastRouteChangeAt !== curTime) {
                    return;
                }
                setPreviousPageClass('beneath');
            }, 400);
        }, 0);
    }, [
        router.route,
        hasNavigatedRef,
        lastSwipeGestureAtRef,
    ]);
    const journeyAppContextValue = react_1.useMemo(() => ({
        error,
        setError,
        hasNavigatedRef,
        alert: alertPayload,
        setAlert: setAlertPayload,
        authed,
    }), [alertPayload, authed, error]);
    react_1.useEffect(() => {
        router_1.Router.events.on('routeChangeStart', () => {
            previousPageHtmlRef.current = helpers_1.getPreviousPageHTML(appEleRef.current);
        });
    }, []);
    return (react_1.default.createElement(JourneyAppContext_1.JourneyAppContext.Provider, { value: journeyAppContextValue },
        react_1.default.createElement(head_1.default, null,
            react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0, viewport-fit=cover" })),
        react_1.default.createElement(NoSSRStatusBarNotch, null),
        react_1.default.createElement(Alert_1.Alert, null),
        react_1.default.createElement("div", { className: classnames_1.default('j-previous-page', previousPageClass), dangerouslySetInnerHTML: { __html: previousPageHtmlRef.current } }),
        react_1.default.createElement("div", { className: classnames_1.default('j-app', appClass), ref: appEleRef }, children),
        react_1.default.createElement(ErrorToolTip_1.ErrorToolTip, null)));
};
exports.default = withJourney_1.default('', JourneyApp, { wrapsHref: false, collapseInModal: 'skipped' });
